import React, { useState, useEffect } from "react";
import "../UnassignModal/UnassignReasonModal.css";

export default function AssignReasonModal({ isOpen, onClose, onConfirm, loading = false }) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (isOpen) setReason("");
  }, [isOpen]);

  if (!isOpen) return null;

  const canConfirm = reason.trim().length > 0 && !loading;

  const handleConfirm = () => {
    if (!canConfirm) return;
    onConfirm(reason.trim());
  };

  return (
    <div
      className="uam-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="aam-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="uam-modal">
        <div className="uam-header">
          <h2 id="aam-title" className="uam-title">Assign Episode</h2>
          <button className="uam-close" aria-label="Close" onClick={onClose}>×</button>
        </div>

        <div className="uam-body">
          <label className="uam-label" htmlFor="aam-reason">
            Reason<span className="uam-required">*</span>
          </label>
          <textarea
            id="aam-reason"
            className="uam-textarea"
            placeholder="Enter reason for assigning this episode..."
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            autoFocus
          />
          <p className="uam-helper-text">
            A reason is required before this episode can be assigned.
          </p>
        </div>

        <div className="uam-footer">
          <button type="button" className="uam-btn uam-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="uam-btn uam-btn-primary"
            onClick={handleConfirm}
            disabled={!canConfirm}
          >
            {loading ? "Assigning..." : "OK"}
          </button>
        </div>
      </div>
    </div>
  );
}